import React from 'react'

const PaginationLink = ({ url = '' }) => {
  return (
    <>
      <a href={`${url}`}>next page</a>
      <style jsx>{`
        a {
          display: none;
        }
      `}</style>
    </>
  )
}

export default PaginationLink
